import '../globals';
import {initFixedFilters} from "./FixedFilters";

;(function ($, _, document, globalUrls, globalTranslations) {
    'use strict';

    var pluginName = 'productFilters';

    function Plugin(element, version) {
        this.element = $(element);
        this.elementId = element.id;
        this._name = pluginName;
        this.requestArguments = $.fn.requestArguments();
        this.type = 'search';
        this.fulltextSearchType = 'exact';
        this.version = typeof version !== 'undefined' ? version : 'v1';
        this.init();

        return this;
    }

    $.extend(Plugin.prototype, {

        /**
         * Init
         */
        init: function () {
            this.fulltextSearchType = this.element.data('fulltext-search-type');
            this.scrollTo = this.element.data('scroll-to');

            if (this.scrollTo) {
                this.requestArguments.setFragment(this.scrollTo);
            }

            switch (this.element.data('filter-type')) {
                case 'search':
					switch (this.version) {
						case 'v2':
							this.initializeSelects();
							this.preventPriceDropdownToggle();
							this.initializeApplyButton();
							this.initializeApplySingleDropdown();
							this.initializeRemoveAllFiltersButton();
							this.initializeRemoveFilter();
							break;
						// case 'v1':
						default:
							this.getFilter();
							break;
					}
					break;
				case 'category':
				case 'dynamicCategory':
                    this.type = this.element.data('filter-type');
                    switch (this.version) {
                        case 'v2':
                            this.initializeSelects();
                            this.preventPriceDropdownToggle();
                            this.initializeApplyButton();
                            this.initializeApplySingleDropdown();
                            this.initializeRemoveAllFiltersButton();
                            this.initializeRemoveFilter();
                            break;
                        // case 'v1':
                        default:
							this.requestArguments.addArgument('filter.category', $('.category-page').data('category'));
							switch ($('.category-page').data('type')) {
								case 'new':
									this.requestArguments.addArgument('filter.neu', 'ja');
									break;
								case 'sale':
									this.requestArguments.addArgument('filter.guenstig-einkaufen', 'Sale');
									break;
								case 'top':
									this.requestArguments.addArgument('filter.guenstig-einkaufen', 'Top');
									break;
								case 'secondQualityGoods':
									this.requestArguments.addArgument('filter.guenstig-einkaufen', 'B-Ware');
									break;
							}
                            this.getFilter();
                            break;
                    }
                    break;
                case 'details':
                    this.initializeSelects();
                    this.initializeApplySingleDropdown();
                    this.initializeRemoveAllFiltersButton();
                    this.initializeRemoveFilter();
                    break;
                case 'orderItems':
                    this.hideMostFilters();
                    this.initializeShowMoreFiltersButton();
                    this.initializeSelects();
                    this.initializePriceSlider();
                    this.preventPriceDropdownToggle();
                    this.initializeDateRangeFilter();
                    this.initializeTermFilter();
                    this.initializeApplyButton();
                    this.initializeApplySingleDropdown();
                    this.initializeRemoveAllFiltersButton();
                    this.initializeRemoveFilter();
                    break;
                case 'article-details':
                    this.type = 'article-details';
                    this.initializeSelects();
                    this.initializeApplySingleDropdown();
                    this.initializeRemoveAllFiltersButton();
                    this.initializeRemoveFilter();
                    break
                case 'prefiltered':
					switch (this.version) {
						case 'v2':
							this.initializeSelects();
							this.preventPriceDropdownToggle();
							this.initializeApplyButton();
							this.initializeApplySingleDropdown();
							this.initializeRemoveAllFiltersButton();
							this.initializeRemoveFilter();
							break;
						// case 'v1':
						default:
							this.getFilter();
							break;
					}
					break;
            }
        },

        /**
         * Get filter
         */
        getFilter: function() {
            var that = this;

            $.ajax({
                url: globalUrls.searchFilterLink,
                data: {
                    productTaggingNode: that.element.data('product-tagging-node'),
                    filterType: 'filter',
                    searchTerm: that.requestArguments.getArguments()['searchterm'],
                    filters: that.element.data('filter'),
                    showCategory: that.element.data('show-category'),
                    distinctField: this.type === 'search' ? 'article.itemId.keyword' : 'productSku',
                    fulltextSearchType: that.fulltextSearchType
                }
            }).done(function (data) {
                that.element.html(data);
                that.hideMostFilters();
                that.initializeShowMoreFiltersButton();
                that.initializeSelects();
                that.initializePriceSlider();
                that.preventPriceDropdownToggle();
                that.initializeApplyButton();
                that.initializeApplySingleDropdown();
                that.initializeRemoveAllFiltersButton();
                that.initializeRemoveFilter();

                initFixedFilters();
            });
        },

        /**
         * Hide all filters except the first few rows
         */
        hideMostFilters: function() {

            const firstFilterCount = this.element[0].dataset.firstFilterCount || 5;

            this.element.find('.show-less-filters').hide();
            if (this.element.find('.filter-col:not(.filter-has-no-values)').length > firstFilterCount) {
                this.element.find('.show-more-filters').show();
                this.element.find('.filter-col:not(.filter-has-no-values)').each(function (index) {
                    if (index + 1 > firstFilterCount) {
                        $(this).hide();
                    }
                });
            } else {
                this.element.find('.show-more-filters').hide();
            }
        },

        /**
         * Initialize ShowMoreFilters-Button
         */
        initializeShowMoreFiltersButton: function () {
            var that = this;

            that.element.on('click touchend', '.show-more-filters', function() {
                var noMoreFilters = true;
                var i = 1;
                that.element.find('.filter-col:not(.filter-has-no-values):hidden').each(function() {
                    // show 5 new filters
                    if (i <= 5) {
                        $(this).show();
                    } else {
                        noMoreFilters = false;
                    }
                    i++;
                });
                if (noMoreFilters) {
                    $(this).hide();
                    $(this).next().show();
                }

                const reinitDropdownEvent = new Event('plandent.reinit.bootstrapDropdown');
                document.dispatchEvent(reinitDropdownEvent)

                const updateFixedFilter = new Event('plandent.fixedFilter.updateHiddenFields');
                $('.fixable-filter-boxes').each((index, filter) => {
                    filter.dispatchEvent(updateFixedFilter);
                });
            });

            that.element.on('click touchend', '.show-less-filters', function() {
                that.hideMostFilters();
            });


            const filterColsMore = that.element.find('.filter-col.more-filter');
            if (filterColsMore.length === 0) {
                const toggleFilters = that.element.find('.show-more-filters,.show-less-filters');
                if (toggleFilters.length > 0) {
                    $(toggleFilters).each((id, toggleFilter) => {
                        $(toggleFilter).addClass('d-none');
                    });
                }
            }
        },

        /**
         * Initialize the selectboxes
         */
        initializeSelects: function() {
            this.element.find('select.selectpicker').selectpicker({
                style: ''
            });

            this.addApplyButtonToSelect();
            this.adjustHeightOfMultipleSelects();

            initFixedFilters();
        },

        /**
         * Add apply button to multiple selects
         */
        addApplyButtonToSelect: function() {
            this.element.find('select.selectpicker').on('loaded.bs.select', function () {
                if ($(this).attr('multiple') == 'multiple') {
                    var dropdownMenu = $(this).parent().find('div.dropdown-menu');
                    dropdownMenu.append('<div class="apply-button"><button class="btn btn-primary">' + globalTranslations.searchFilterApplyButton + '</button></div>');
                }
            });
        },

        /**
         * If the select is multiple and has a lot of options, the height must be adjusted
         */
        adjustHeightOfMultipleSelects: function() {
            this.element.find('select.selectpicker').on('shown.bs.select', function (e) {
                if ($(this).attr('multiple') == 'multiple') {
                    var dropdownMenu = $(this).parent().find('div.dropdown-menu');
                    var oldMaxHeight = parseInt(dropdownMenu.css('max-height').replace('px', ''));
                    dropdownMenu.css('max-height', (oldMaxHeight + 40) + 'px');
                }
            });
        },

        /**
         * Initialize price range slider
         */
        initializePriceSlider: function() {
            var that = this;

            that.element.find('input.slider').each(function() {
				var slider = $(this).bootstrapSlider();

                slider.on('change', function(){
                    var value = $(this).val();
                    var values = value.split(',');
                    that.element.find('.price-filter .price-from').val(values[0]);
                    that.element.find('.price-filter .price-until').val(values[1]);
                });

                that.element.find('.price-filter').on('keyup', 'input', function() {
                    var min = _.toInteger(that.element.find('.price-filter input.price-from').val());
                    var max = _.toInteger(that.element.find('.price-filter input.price-until').val());

                    if (min > max) {
                        var tmp = min;
                        min = max;
                        max = tmp;
                    }

                    that.element.find('input.slider').bootstrapSlider('setValue', [min, max]);
                });
            });
        },

        /**
         * If the price dropdown is clicked, the dropdown should not be closed
         */
        preventPriceDropdownToggle: function() {
            this.element.on('click touchend', '.price-filter', function(e) {
                e.preventDefault();
                return false;
            });
        },

        /**
         * Initialize the apply buttons
         */
        initializeApplyButton: function() {
            var that = this;

            that.element.on('click touchend', '.apply-button .btn', function() {
                var selectElement = $(this).parents('.bootstrap-select').find('select.selectpicker');
                if (selectElement.length > 0) {
                    that.applyFilter(
                        selectElement.attr('name'),
                        selectElement.selectpicker('val')
                    );
                }

                var priceElement = $(this).parents('.bootstrap-select').find('input.slider');
                if (priceElement.length > 0) {
                    that.applyFilter(
                        priceElement.attr('name'),
                        priceElement.val()
                    );
                }
            });
        },

        /**
         * Add apply listener to single dropdown
         */
        initializeApplySingleDropdown: function() {
            var that = this;

            that.element.find('select.selectpicker').on('changed.bs.select', function (e) {
                if ($(this).attr('multiple') != 'multiple') {
                    that.applyFilter(
                        $(this).attr('name'),
                        $(this).selectpicker('val')
                    );
                }
            });
        },

        /**
         * Initialize RemoveFiltersButton
         */
        initializeRemoveAllFiltersButton: function() {
            var that = this;

            that.element.on('click touchend', '.remove-all-filters', function () {
                that.requestArguments.removeArgument('filter');
                if (that.element[0] && that.element[0].dataset.enableSearch) {
                    that.requestArguments.removeArgument('searchterm');
                }
                if (that.element[0].querySelector('.filter-col select[name="period"]')) {
                    that.requestArguments.addArgument('filter', {'period': 'all'});
                }

                that.requestArguments.setFragment(that.elementId);
                that.requestArguments.redirectToArguments(that.getAlternativeLocation());
            });
        },

        /**
         * Initialize RemoveFiltersButton
         */
        initializeRemoveFilter: function() {
            var that = this;

            that.element.on('click touchend', '.filter-value', function () {
                that.removeFilter($(this).data('filter'), $(this).data('value'), $(this).data('type'));
            });
        },

        /**
         * Initialize DateRangeFilter
         */
        initializeDateRangeFilter: function () {
            var that = this;

            var datepickerStart = that.element.find('input.date-range[data-range-start="true"]').parent();
            var datepickerEnd = that.element.find('input.date-range[data-range-start="false"]').parent();

            var minDate = that.requestArguments.getArgument('filter.StartDatum', false);
            if (minDate !== false) {
                minDate = moment(minDate);
            }
            var maxDate = that.requestArguments.getArgument('filter.EndDatum');
            maxDate = moment(maxDate);

            datepickerStart.dateTimePicker({
                format: 'DD.MM.YYYY',
                useDefaultDate: false,
                minDate: minDate,
                maxDate: maxDate
            });
            datepickerEnd.dateTimePicker({
                format: 'DD.MM.YYYY',
                useDefaultDate: false,
                minDate: minDate,
                maxDate: maxDate
            });

            var changed = false;
            datepickerStart.on("dp.change", function (e) {
                minDate = e.date;
                if (datepickerEnd.length > 0) {
                    datepickerEnd.data("DateTimePicker").minDate(minDate);
                }
                changed = true;
            });
            datepickerEnd.on("dp.change", function (e) {
                maxDate = e.date;
                if (datepickerStart.length > 0) {
                    datepickerStart.data("DateTimePicker").maxDate(maxDate);
                }
                changed = true;
            });

            that.element.find('input.date-range').parent().on("dp.show", function (e) {
                $(this).addClass('show');
            });

            that.element.find('input.date-range').parent().on("dp.hide", function (e) {
                $(this).removeClass('show');
                if (!changed) {
                    return;
                }

                that.applyFilter(
                    $(this).children('input').attr('name'),
                    e.date.format('YYYY-MM-DD')
                );
            });
        },

        /**
         * Initialize term filter
         */
        initializeTermFilter: function() {
            var that = this;
            var searchInput = that.element.find('input[type="search"]');

            searchInput.keypress(function (e) {
                if (e.which == 13) {
                    that.requestArguments.addArgument('searchterm', searchInput.val());
                    that.requestArguments.addArgument('sort', 'relevance');
                    that.requestArguments.redirectToArguments();
                }
            });

            $(searchInput).next().on('click touchend', function () {
                that.requestArguments.addArgument('searchterm', searchInput.val());
                that.requestArguments.addArgument('sort', 'relevance');
                that.requestArguments.redirectToArguments();
            });
        },

        /**
         * Remove filter and reload page
         *
         * @param filter
         * @param value
         * @param type
         */
        removeFilter: function(filter, value, type) {
            if (type === 'multipleDropdown') {
                var filterArgument = this.requestArguments.getArgument(['filter', filter]);
                var filterArguments = _.split(filterArgument, '|');
                var newFilterArguments = _.remove(filterArguments, function (argumentValue) {
                    return value != argumentValue;
                });

                if (filter === 'period') {
                    newFilterArguments = ['all'];
                }

                if (_.isEmpty(newFilterArguments)) {
                    this.requestArguments.removeArgument(['filter', filter]);
                } else {
                    this.requestArguments.addArgument(['filter', filter], newFilterArguments);
                }
            } else {
                this.requestArguments.removeArgument(['filter', filter]);
            }
            if (this.type === 'category') {
                this.requestArguments.removeArgument(['filter', 'category']);
            }

            this.requestArguments.setFragment(this.elementId);
            this.requestArguments.redirectToArguments(this.getAlternativeLocation());
        },

        /**
         * Apply filter and reload page
         *
         * @param name
         * @param value
         */
        applyFilter: function(name, value) {
            this.requestArguments.removeArgument(['redirect']);
            if (_.isEmpty(value)) {
                this.requestArguments.removeArgument(['filter', name]);
            } else {
                this.requestArguments.addArgument(['filter', name], value);
            }

            if (this.type === 'category') {
                this.requestArguments.removeArgument(['filter', 'category']);
            }

            this.requestArguments.setFragment(this.elementId);
            this.requestArguments.redirectToArguments(this.getAlternativeLocation());
        },

        /**
         * Get Alternative location
         *
         * @returns string|null
         */
        getAlternativeLocation: function() {
            if (this.type === 'article-details') {
                return this.element.data('product-link');
            } else {
                return null;
            }
        }
    });

    /**
     * Plugin wrapper
     */
    $.fn[pluginName] = function (version) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new Plugin(this, version));
            }
        });
    };
})(jQuery, _, document, globalUrls, globalTranslations);
